import PropTypes from 'prop-types';
import styles from './Tile.module.scss';
import Button from '../../atoms/Button';

/**
 * A card with a icon, heading, content, buttonText and onClick event
 */
export default function Tile({
  icon,
  heading,
  content,
  buttonText,
  onClick,
}) {
  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={onClick} className={styles.tile} type="button">
      <div className={styles.tile__top}>
        {icon && (
          <div className={styles.tile__icon}>
            {typeof icon === 'function' ? icon() : icon}
          </div>
        )}
        {heading && <h2 className={styles.tile__heading}>{heading}</h2>}
      </div>
      {content && <div className={styles.tile__content}>{content}</div>}
      {buttonText && onClick && <Button onClick={onClick}>{buttonText}</Button>}
    </div>
  );
}

Tile.defaultProps = {
  icon: null,
  heading: '',
  content: '',
  buttonText: '',
  onClick: () => {},
};

Tile.propTypes = {
  /**
   * Icon for tile
   */
  icon: PropTypes.func,
  /**
   * Heading for tile
   */
  heading: PropTypes.string,
  /**
   * Content for tile
   */
  content: PropTypes.string,
  /**
   * Button text for button within tile
   */
  buttonText: PropTypes.string,
  /**
   * OnClick event for tile
   */
  onClick: PropTypes.func,
};
